import React, { useState, useRef, useEffect } from 'react'
import Schedule from '../../../assets/images/schedule.svg'
import { Flex, ResponsiveSVG } from 'ui/acro'
import styled from 'styled-components'
import Text from 'ui/acro/typography/Text'
import AddToCalendarModal from './AddToCalendarModal'
import CoachMark from './CoachMark'
import { useModal_deprecated } from 'hooks'
import { axios } from 'api'
import { useCookies } from 'react-cookie'

const Container = styled(Flex)`
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
`
const CTAText = styled(Text)({
  fontSize: ['14px'],
  fontFamily: 'Proxima-nova',
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '0.308px',
  color: '#000'
})

const AddToCalendar = (props) => {
  const [cookies, setCookie] = useCookies(['class_schedule_closed'])
  const addToCalendarRef = useRef(null)
  const modal = useModal_deprecated()
  const [showAlert, setShowAlert] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      if (cookies?.class_schedule_closed !== 'true') {
        axios
          .get('/user_popups')
          .then((res) => {
            if ((res?.data?.popups || []).includes('class_schedule_popup')) {
              setShowAlert(true)
            } else {
              setCookie('class_schedule_closed', 'true', { path: '/' })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }, 2000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <Container
        ref={addToCalendarRef}
        onClick={() => modal.open()}
        id='schedule-button'
      >
        <ResponsiveSVG
          SVG={Schedule}
          style={{
            cursor: 'pointer'
          }}
          width='24px'
          height='24px'
        />
        <CTAText>Schedule</CTAText>
      </Container>
      <AddToCalendarModal useModal={modal} classDetails={props} />
    </>
  )
}
export default AddToCalendar
